import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import patientService from "../../../../../services/patient.service"
import Loading from "../../../../common/Loading"
import { useEyeconxStore } from "../../../../../store/eyeconxStore";
const PatientCommunicationPreferenceCard = ({ patientId }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(false);

 const clinicId = useEyeconxStore((state) => state.user.clinicId);
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { isDirty }
  } = useForm();

  const formValues = watch();

  useEffect(() => {
    fetchPreferences();
  }, []);

  const fetchPreferences = async () => {
    try {
      setLoading(true);
      const res = await patientService.getCommunicationPreferences(clinicId,patientId);
      setSettings(res.data);
      reset(res.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (data) => {
    try {
      const res = await patientService.updateCommunicationPreferences(patientId, data);
      setSettings(res.data);
      reset(res.data);
      setIsEditing(false);
    } catch (e) {
      console.error(e);
    }
  };

  const handleCancel = () => {
    reset(settings);
    setIsEditing(false);
  };

  if (loading) return <Loading />;

  return (
    <>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">
          <i className="bi bi-chat-dots-fill text-primary me-2"></i>
          Communication Preferences
        </h5>

        {!isEditing ? (
          <button className="btn btn-outline-primary" onClick={() => setIsEditing(true)}>
            <i className="bi bi-pencil me-1"></i> Edit
          </button>
        ) : (
          <div className="d-flex gap-2">
            <button className="btn btn-secondary" onClick={handleCancel}>
              Cancel
            </button>
            <button
              className="btn btn-primary text-white"
              onClick={handleSubmit(onSubmit)}
              disabled={!isDirty}
            >
              Save
            </button>
          </div>
        )}
      </div>

      {settings && (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row g-4">

            {/* Communication Channels */}
            <Card title="Communication Channels" icon="telephone-fill">
              <Toggle col="4" name="isEmail" label="Email" />
              <Toggle col="4" name="isSms" label="SMS" />
              <Toggle col="4" name="isCall" label="Phone Call" />

              <Select col="4" name="prefEmail" label="Email Priority" />
              <Select col="4" name="prefSms" label="SMS Priority" />
              <Select col="4" name="prefCall" label="Call Priority" />
            </Card>

            {/* Notification Types */}
            <Card title="Notifications & Content" icon="bell-fill">
              <Toggle col="3" name="isReminder" label="Reminders" />
              <Toggle col="3" name="isNewsletter" label="Newsletter" />
              <Toggle col="3" name="isArticle" label="Articles" />
              <Toggle col="3" name="isRecall" label="Recall" />

              <Toggle col="3" name="isGlass" label="Glasses" />
              <Toggle col="3" name="isLens" label="Lenses" />
              <Toggle col="3" name="isLensOrder" label="Lens Orders" />
              <Toggle col="3" name="isSurvey" label="Survey" />

              <Toggle col="3" name="isThankyou" label="Thank You" />
              <Toggle col="3" name="isFollowup" label="Follow-up" />
              <Toggle col="3" name="isBirthday" label="Birthday" />
            </Card>
          </div>
        </form>
      )}
    </>
  );

  /* ---------------- Reusable Components ---------------- */

  function Card({ title, icon, children }) {
    return (
      <div className="col-12">
        <div className="card bg-light border-0 shadow-sm">
          <div className="card-header bg-transparent border-0">
            <h6 className="mb-0">
              <i className={`bi bi-${icon} text-primary me-2`}></i>
              {title}
            </h6>
          </div>
          <div className="card-body">
            <div className="row g-3">{children}</div>
          </div>
        </div>
      </div>
    );
  }

  function Toggle({ name, label, col }) {
    const value = isEditing ? formValues[name] : settings[name];

    return (
      <div className={`col-md-${col}`}>
        <div className="setting-item">
          <div className="d-flex justify-content-between align-items-center">
            <span className="fw-semibold">{label}</span>
            {isEditing ? (
              <div className="form-check form-switch">
                <input
                  type="checkbox"
                  className="form-check-input"
                  {...register(name)}
                />
              </div>
            ) : (
              <span className={`badge ${value ? "bg-success" : "bg-secondary"}`}>
                {value ? "Enabled" : "Disabled"}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }

  function Select({ name, label, col }) {
    const value = isEditing ? formValues[name] : settings[name];

    return (
      <div className={`col-md-${col}`}>
        <div className="setting-item">
          <label className="fw-semibold mb-1">{label}</label>
          {isEditing ? (
            <select className="form-select" {...register(name)}>
              <option value={1}>1 (Highest)</option>
              <option value={2}>2</option>
              <option value={3}>3 (Lowest)</option>
            </select>
          ) : (
            <div className="fw-medium">{value}</div>
          )}
        </div>
      </div>
    );
  }
};

export default PatientCommunicationPreferenceCard;
